import "./ExperienceDetail.scss";

const Subwise = () => {
  return (
    <div className="experience-detail">
      <div className="experience-detail__container">
        <div className="experience-detail__header">
          <span className="experience-detail__tenure">Side Project - 2025</span>
          <h1 className="experience-detail__title">Subwise Mobile App (EmberLabs)</h1>
        </div>

        <div className="experience-detail__content">
          <section className="experience-detail__section">
            <h2>Overview</h2>
            <p>
              Subwise is a privacy-first, local-first subscription management application designed to help users 
              track recurring expenses without requiring an account. Built with a focus on data privacy, it calculates 
              financial insights entirely on-device, offering localized notifications for bill renewals and 
              "Netflix-style" analytics to visualize spending habits.
            </p>
          </section>

          <section className="experience-detail__section">
            <h2>Key Features</h2>
            <ul>
              <li><strong>Smart Analytics Engine:</strong> Custom algorithm that normalizes recurring costs (weekly vs. yearly) to project monthly burn rates and detect duplicate subscriptions</li>
              <li><strong>Pro-Tier Gating:</strong> Implemented a "freemium" model using RevenueCat, gating users tracking >8 subscriptions or accessing advanced charts</li>
              <li><strong>Local Notification System:</strong> Automated scheduling of renewal reminders (7 days, 3 days, 1 day prior) that auto-reschedules when subscription details change</li>
              <li><strong>Custom UI System:</strong> Built a custom design system including a Glassmorphic tab bar, animated charts, and haptic feedback integrations</li>
            </ul>
          </section>

          <section className="experience-detail__section">
            <h2>Technical Challenges</h2>
            <ul>
              <li><strong>Complex Date Math:</strong> Handling billing cycle logic with custom utilities to normalize costs across different currencies and billing periods while accounting for leap years and varying month lengths</li>
              <li><strong>Offline-First Architecture:</strong> Built robust data migration scripts to ensure existing user data on-device was migrated seamlessly without corruption</li>
              <li><strong>Chart Performance:</strong> Optimized rendering of interactive charts on older Android devices by memoizing heavy calculation functions and lazy-loading chart components</li>
            </ul>
          </section>

          <section className="experience-detail__section">
            <h2>Tech Stack</h2>
            <div className="experience-detail__tags">
              <span className="experience-detail__tag">React Native</span>
              <span className="experience-detail__tag">Expo SDK 54</span>
              <span className="experience-detail__tag">TypeScript</span>
              <span className="experience-detail__tag">AsyncStorage</span>
              <span className="experience-detail__tag">RevenueCat</span>
              <span className="experience-detail__tag">Expo Router</span>
            </div>
          </section>

          <section className="experience-detail__section">
            <h2>Milestones</h2>
            <ul>
              <li><strong>v1.0 (April 2025):</strong> Initial MVP launch focusing on basic listing and manual entry</li>
              <li><strong>v2.0 (Dec 2025):</strong> Complete UI overhaul with "Glassmorphism" design language and expanded free tier</li>
              <li><strong>v2.1 (Jan 2026):</strong> Performance optimization suite, reducing load times and implementing a catalogue of 120+ pre-filled popular services</li>
            </ul>
          </section>
        </div>

        <a href="/" className="experience-detail__back-link">← Back to Portfolio</a>
      </div>
    </div>
  );
};

export default Subwise;
